/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const MessageSquareDashed = createLucideIcon("message-square-dashed", [
  ["path", { d: "M14 3h2", key: "1d12a5" }],
  ["path", { d: "M16 19h-2", key: "1agirb" }],
  ["path", { d: "M2 12v-2", key: "1ey295" }],
  ["path", { d: "M2 16v5.286a.71.71 0 0 0 1.212.502l1.149-1.149", key: "120k8q" }],
  ["path", { d: "M20 19a2 2 0 0 0 2-2v-1", key: "ior8tn" }],
  ["path", { d: "M22 10v2", key: "rmlecy" }],
  ["path", { d: "M22 6V5a2 2 0 0 0-2-2", key: "sp3k6r" }],
  ["path", { d: "M4 3a2 2 0 0 0-2 2v1", key: "11zt7s" }],
  ["path", { d: "M8 19h2", key: "jnunrx" }],
  ["path", { d: "M8 3h2", key: "ysbsee" }]
]);

export { MessageSquareDashed as default };
//# sourceMappingURL=message-square-dashed.js.map
